module.exports = __webpack_public_path__ + "static/media/CTLI_8-391w.4eca9393.jpg";